import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AttachmentType } from 'src/app/shared/models/misc.model';

import { BasicService } from 'src/app/shared/services/basic.service';
import { UploadService } from 'src/app/shared/services/upload.service';
import { urlValidator } from 'src/app/shared/validators/url.validator';

@Component({
  selector: 'app-bzc-richlink-modal',
  templateUrl: './bzc-richlink-modal.component.html',
  styleUrls: ['./bzc-richlink-modal.component.scss'],
})
export class BZCRichLinkModalComponent {
  @Input() siteId: number;
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  richLinkForm = new FormGroup(
    {
      title: new FormControl('', [Validators.required]),
      url: new FormControl('', [Validators.required, urlValidator]),
    },
    () => (this.pictureId || this.videoId ? null : { mediaRequired: true })
  );

  pictureURL: string;
  videoURL: string;
  isUploading = false;
  uploadProgress$ = new BehaviorSubject<number>(0);

  private pictureId: number;
  private videoId: number;
  private currentAttachmentType: AttachmentType;

  constructor(private basicService: BasicService, private uploadService: UploadService) {}

  // convenience getters
  get title() {
    return this.richLinkForm.get('title');
  }

  get url() {
    return this.richLinkForm.get('url');
  }

  cancel() {
    this.basicService.dismissModal(null);
  }

  ok() {
    const richLink = {
      ...this.richLinkForm.value,
      pictureId: this.pictureId,
      videoId: this.videoId,
    };
    this.basicService.dismissModal(richLink);
  }

  selectPicture() {
    this.triggerFileDialog(AttachmentType.Picture, 'image/*');
  }

  selectVideo() {
    this.triggerFileDialog(AttachmentType.Video, 'video/*');
  }

  removePicture() {
    this.pictureId = null;
    this.pictureURL = null;
    this.richLinkForm.updateValueAndValidity();
  }

  removeVideo() {
    this.videoId = null;
    this.videoURL = null;
    this.richLinkForm.updateValueAndValidity();
  }

  onFileSelected($event) {
    const file = $event.target.files?.item(0);
    this.isUploading = true;
    this.uploadProgress$.next(0);
    this.uploadService
      .uploadMedia(file, this.currentAttachmentType, this.siteId, this.uploadProgress$, false)
      .pipe(finalize(() => (this.isUploading = false)))
      .subscribe(mediaId => this.afterMediaUpload(mediaId));
  }

  private afterMediaUpload(mediaId) {
    if (this.currentAttachmentType === AttachmentType.Picture) {
      this.pictureId = mediaId;
      this.pictureURL = this.uploadService.pictureUrl(mediaId);
    } else {
      this.videoId = mediaId;
      this.videoURL = this.uploadService.videoUrl(mediaId);
    }
    this.richLinkForm.updateValueAndValidity();
  }

  private triggerFileDialog(attachmentType, accept) {
    this.currentAttachmentType = attachmentType;
    this.fileInput.nativeElement.setAttribute('accept', accept);
    this.fileInput.nativeElement.value = ''; // allow selecting the same file again
    this.fileInput.nativeElement.click();
  }
}
